export default "__VITE_ASSET__C60TYgCc__"